class OgrnValidator {
	
	regexp = /^([0-9]{13})$/;
	message: string = '';

	validate = ( value: string ): boolean => {
		this.message = 'Поле должно содержать 13 цифр';
		if ( !this.regexp.test(value) )
			return false;

		const val = parseInt(value.substring(0, 12));
		const checksum = parseInt(value[12]);

		this.message = 'Некорректный ОГРН';
		return (val % 11 % 10) === checksum;
	};

};

export default OgrnValidator;
